/**
 * Pass a card or tab permissions object and check if the user has permission to view it
 * NB: if no permissions object is passed or both usergroupIds[] excludedUsergroupIds[] are empty, then the user DOES have permission
 * NB: if the usergroupIds[] and excludedUsergroupIds[] contain the same ids, then the user DOES have permission
 */
export const hasViewPermission = (
  userUsergroupIds: string[],
  permissions?: { disabled?: boolean; usergroupIds?: string[]; excludedUsergroupIds?: string[] },
): boolean => {
  if (permissions?.disabled) {
    return false;
  }

  // If both permissions arrays are empty then the user has permission
  if (!permissions?.usergroupIds?.length && !permissions?.excludedUsergroupIds?.length) {
    return true;
  }

  if (permissions.usergroupIds && permissions.usergroupIds.length > 0) {
    if (permissions.usergroupIds.some((id) => userUsergroupIds.includes(id))) {
      return true;
    }
  }

  if (permissions.excludedUsergroupIds && permissions.excludedUsergroupIds.length > 0) {
    if (permissions.excludedUsergroupIds.every((id) => !userUsergroupIds.includes(id))) {
      return true;
    }
  }

  return false;
};
